/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pdf-icon': {
    width: 27,
    height: 23,
    viewBox: '0 0 27 23',
    data: '<g _fill="none" fill-rule="evenodd"><g _stroke="#C91600"><path pid="0" d="M1.5 1.318v21h14.826l.191-15h-5.626l-.205-6H1.5z"/><path pid="1" stroke-linecap="round" stroke-linejoin="round" d="M10.743 1.36l5.74 5.896"/></g><path pid="2" _fill="#C91600" d="M4.935 9.782h21.022v9.699H4.935z"/><text _fill="#FFF" font-family="AvenirNext-DemiBold, Avenir Next" font-size="9.5" font-weight="500"><tspan x="6.051" y="17.981">PDF</tspan></text></g>'
  }
})
